/* MOD'S product page — progressive enhancement, no dependencies.
   - Variant switching is instant and offline: all variant data ships in a
     small JSON block, so no network request happens on selection (ideal for
     slow/unstable connections).
   - The add-to-cart form is a plain native POST: it works with JS disabled.
   - ES5 syntax only, so very old phones are supported. */
(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  /* ---------- money formatting (uses shop money format from Liquid) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    if (typeof cents === 'number') {
      switch ((format.match(placeholderRegex) || [])[1]) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }
    }
    return format.replace(placeholderRegex, value);
  }

  /* ---------- per-section initialisation ---------- */
  function init(root) {
    if (!root || root.getAttribute('data-mods-ready') === '1') return;
    root.setAttribute('data-mods-ready', '1');
    var dataEl = qs('[data-mods-product-json]', root);
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var moneyFormat = data.moneyFormat || '{{ amount }}';
    var strings = data.strings || {};

    var form = qs('form[data-mods-form]', root);
    var idInput = qs('input[name="id"]', form);
    var atcBtn = qs('[data-mods-atc]', root);
    var atcLabel = qs('[data-mods-atc-label]', root);
    var sticky = qs('[data-mods-sticky]', root);
    var stickyTitle = qs('[data-mods-sticky-title]', root);
    var stickyPrice = qs('[data-mods-sticky-price]', root);
    var radios = qsa('input[type="radio"][data-mods-variant]', root);

    function variantById(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    function update(variant) {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;

      var priceText = formatMoney(variant.price, moneyFormat);

      if (variant.available) {
        if (atcBtn) atcBtn.removeAttribute('disabled');
        if (atcLabel) atcLabel.textContent = (strings.addToCart || 'Add to cart') + ' — ' + priceText;
      } else {
        if (atcBtn) atcBtn.setAttribute('disabled', 'disabled');
        if (atcLabel) atcLabel.textContent = strings.soldOut || 'Sold out';
      }

      if (stickyTitle) stickyTitle.textContent = data.productTitle + ' · ' + variant.title;
      if (stickyPrice) stickyPrice.textContent = variant.available ? priceText : (strings.soldOut || 'Sold out');

      /* checked-card fallback for browsers without :has() */
      qsa('.opt', root).forEach(function (card) {
        var input = qs('input[type="radio"]', card);
        var on = input && String(input.value) === String(variant.id);
        if (card.classList) {
          if (on) { card.classList.add('is-checked'); }
          else { card.classList.remove('is-checked'); }
        }
      });

      /* deep-link the variant so refreshes/shares keep the selection */
      if (window.history && history.replaceState) {
        var url = window.location.href.split('?')[0];
        history.replaceState({}, '', url + '?variant=' + variant.id);
      }
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        update(variantById(r.value));
      });
      if (r.checked) {
        var card = r.closest ? r.closest('.opt') : null;
        if (card && card.classList) card.classList.add('is-checked');
      }
    });

    /* ---------- gallery ----------
       One delegated listener instead of one per thumb: lighter on old phones
       and still correct if Shopify re-renders the media list. */
    var mainImg = qs('[data-mods-gallery-main]', root);
    var strip = qs('.gal-t', root);
    if (mainImg && strip) {
      strip.addEventListener('click', function (ev) {
        var btn = ev.target;
        while (btn && btn !== strip && !(btn.getAttribute && btn.getAttribute('data-mods-thumb') !== null)) {
          btn = btn.parentNode;
        }
        if (!btn || btn === strip) return;
        var src = btn.getAttribute('data-src');
        if (!src) return;
        var srcset = btn.getAttribute('data-srcset');
        if (srcset) mainImg.setAttribute('srcset', srcset);
        mainImg.setAttribute('src', src);
        var alt = btn.getAttribute('data-alt');
        if (alt != null) mainImg.setAttribute('alt', alt);
        qsa('[data-mods-thumb]', strip).forEach(function (o) {
          o.setAttribute('aria-current', o === btn ? 'true' : 'false');
        });
      }, false);
    }

    /* ---------- sticky add-to-cart bar ----------
       IntersectionObserver alone misses the case where the ATC button is
       below the fold on load (small screens): no intersection transition
       ever fires. A rAF-throttled scroll check is reliable everywhere. */
    var anchor = qs('.atc', root);
    if (sticky && anchor) {
      var ticking = false;
      var checkSticky = function () {
        ticking = false;
        var past = anchor.getBoundingClientRect().bottom < 0;
        if (sticky.classList) {
          if (past) { sticky.classList.add('on'); }
          else { sticky.classList.remove('on'); }
        }
      };
      var onScroll = function () {
        if (!ticking) {
          ticking = true;
          if (window.requestAnimationFrame) requestAnimationFrame(checkSticky);
          else setTimeout(checkSticky, 66);
        }
      };
      window.addEventListener('scroll', onScroll, false);
      window.addEventListener('resize', onScroll, false);
      checkSticky();
    }

    /* ---------- sticky button submits the real form ---------- */
    var stickyBtn = qs('[data-mods-sticky-btn]', root);
    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }
  }

  function boot() {
    qsa('[data-mods-product]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme Editor: Shopify replaces the section markup on every change, so the
     freshly rendered section has to be initialised again. */
  document.addEventListener('shopify:section:load', function (ev) {
    var scope = ev.target;
    if (!scope) { boot(); return; }
    var roots = qsa('[data-mods-product]', scope);
    if (!roots.length && scope.getAttribute && scope.getAttribute('data-mods-product') !== null) {
      roots = [scope];
    }
    roots.forEach(init);
  }, false);
})();